import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { usePlatformAuth } from "../hooks/usePlatformAuth";
import { Wordmark } from "../components/Wordmark";
import { colors, fontSize, fontWeight, radius, shadow, space } from "../lib/tokens";

export function LoginPage() {
  const { signIn } = usePlatformAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    const { error: err } = await signIn(email, password);
    setSubmitting(false);
    if (err) {
      setError(err);
      return;
    }
    navigate("/");
  }

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: colors.paper, padding: 24 }}>
      <form onSubmit={handleSubmit} style={{ background: colors.white, border: `1px solid ${colors.fog}`, borderRadius: radius.lg, boxShadow: shadow.md, padding: 32, width: "100%", maxWidth: 380 }}>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 6, marginBottom: space.xxxl }}>
          <Wordmark variant="ink" height={26} />
          <div style={{ fontSize: 10, color: colors.stone, textTransform: "uppercase", letterSpacing: "0.08em", paddingLeft: 35 }}>platform admin</div>
        </div>

        <h1 style={{ fontSize: 22, fontWeight: fontWeight.medium, letterSpacing: "-0.015em", marginBottom: 6 }}>Entrar</h1>
        <p style={{ fontSize: fontSize.md, color: colors.stone, marginBottom: space.xxl }}>Acesso restrito à equipe Klubora.</p>

        <label style={{ display: "block", fontSize: fontSize.sm, fontWeight: fontWeight.medium, marginBottom: 6 }}>Email</label>
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" autoFocus
          style={{ width: "100%", height: 36, padding: "0 12px", border: `1px solid ${colors.fog}`, borderRadius: radius.sm, fontSize: fontSize.md, marginBottom: space.lg, background: colors.white }} />

        <label style={{ display: "block", fontSize: fontSize.sm, fontWeight: fontWeight.medium, marginBottom: 6 }}>Senha</label>
        <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password"
          style={{ width: "100%", height: 36, padding: "0 12px", border: `1px solid ${colors.fog}`, borderRadius: radius.sm, fontSize: fontSize.md, marginBottom: space.xl, background: colors.white }} />

        {error && <div style={{ padding: "8px 12px", background: colors.errorSoft, color: colors.error, borderRadius: radius.sm, fontSize: fontSize.sm, marginBottom: space.lg }}>{error}</div>}

        <button type="submit" disabled={submitting} style={{ width: "100%", height: 40, background: colors.ink, color: colors.paper, border: 0, borderRadius: radius.sm, fontSize: fontSize.md, fontWeight: fontWeight.medium, cursor: submitting ? "not-allowed" : "pointer", opacity: submitting ? 0.6 : 1 }}>
          {submitting ? "Entrando..." : "Entrar"}
        </button>
      </form>
    </div>
  );
}
